import React, { useEffect } from "react";
import Helper from "../Helper";
import { CommandCenterView } from "../models/CommandCenterView";

interface LoadingSplashProps {
    image?: string;
    teamLogo?: string;
    propProgress?: number;
    commandCenterView?: CommandCenterView;
}

// This component displays the PLOT logo centered as a splash screen while loading.
const LoadingSplash: React.FC<LoadingSplashProps> = ({ image, teamLogo, propProgress, commandCenterView }) => {
    const [showPlotLogo, setShowPlotLogo] = React.useState(true);
    const [progress, setProgress] = React.useState(0);

    useEffect(() => {
        if (propProgress !== undefined) {
            setProgress(propProgress);
        } else if (commandCenterView) {
            setProgress(100);
        }
    }, [propProgress, commandCenterView]);
    useEffect(() => {
        // Simulate loading progress
        // Delay for 5 seconds. Every second update progress by 20% (100 / 5 = 20)
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + 20;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (progress >= 50 && teamLogo) {
            setShowPlotLogo(false);
        } else {
            setShowPlotLogo(true);
        }
    }, [progress, teamLogo]);

    return (
        <div
            className={Helper.classNames(
                "absolute top-0 left-0 right-0 bg-neutral-900 border-b border-neutral-700 z-1200 w-screen transition-all duration-700 ease-in-out flex items-center justify-center overflow-hidden",
                progress < 100 ? "h-screen" : "h-0"
            )}
        >
            <div style={{ zIndex: -1 }} className="absolute inset-0 flowing-gradient opacity-40" />
            <div className="relative w-2/3 h-auto flex items-center justify-center">
                <img
                    src={image ?? "/img/png/logo/plot_jobsite_command.png"}
                    alt="PLOT Logo"
                    className={`absolute flex transition-opacity duration-700 ease-in-out w-full max-w-2/3 h-auto object-contain opacity-${showPlotLogo ? "75" : "0"} ${showPlotLogo ? "z-10" : "z-0"}`}
                    style={{ opacity: showPlotLogo ? 0.75 : 0, pointerEvents: showPlotLogo ? "auto" : "none" }}
                />
                {teamLogo && (
                    <img
                        src={teamLogo}
                        alt="Team Logo"
                        className={`absolute flex transition-opacity duration-700 ease-in-out w-full max-w-2/3 h-auto object-contain opacity-${showPlotLogo ? "75" : "0"} ${showPlotLogo ? "z-10" : "z-0"}`}
                        style={{ opacity: showPlotLogo ? 0 : 0.75, pointerEvents: showPlotLogo ? "none" : "auto" }}
                    />
                )}
            </div>
        </div>
    );
};

export default LoadingSplash;
